import { Break, Calendar, ScheduleModificationsQueryParams } from '../../calendars/types';
import { deleteRequest, getRequest, getWithParamsRequest, postRequest, putRequest } from '../utils/provider';
import { ApiResponse } from '../utils/responseTransform';

export async function getCalendars(
  queryParams: CalendarQueryParams | null,
  signal?: AbortSignal
): Promise<ApiResponse<{ calendars: Calendar[] }>> {
  return getWithParamsRequest('calendars', queryParams, signal);
}

export async function createCalendar(payload: CalendarFormData): Promise<ApiResponse<Calendar>> {
  return postRequest('calendars', payload);
}

export async function updateCalendar(id: string, payload: CalendarFormData): Promise<ApiResponse<Calendar>> {
  return putRequest(`calendars/${id}`, payload);
}

export async function deleteCalendar(id: string): Promise<ApiResponse> {
  return deleteRequest(`calendars/${id}`);
}

export async function getCalendarDetails(slug: string): Promise<ApiResponse<{ calendar: Calendar }>> {
  return getRequest(`calendars/${slug}`);
}

export async function copyCalendar(id: string): Promise<ApiResponse<Calendar>> {
  return postRequest('calendars', { calendarSlug: id });
}

export async function saveBreak(id: string, data: RestDaysFormData): Promise<ApiResponse<{ break: Break }>> {
  return postRequest('schedule_modifications', { calendarSlug: id, ...data });
}

export async function updateBreak(id: string, payload: RestDaysFormData): Promise<ApiResponse<{ break: Break }>> {
  return putRequest(`schedule_modifications/${id}`, payload);
}

export async function deleteBreak(id: string): Promise<ApiResponse> {
  return deleteRequest(`schedule_modifications/${id}`);
}

export async function getScheduleModifications(
  queryParams: ScheduleModificationsQueryParams,
  signal?: AbortSignal
): Promise<ApiResponse<Break[]>> {
  return getWithParamsRequest('schedule_modifications', queryParams, signal);
}
